export function formatDatesGetMesures(date: Date) {
	const timeZoneOffset = date.getTimezoneOffset() * 60000;

	return new Date(date.getTime() - timeZoneOffset).toISOString();
}
